<template>
  <v-container v-if="!loading">
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-date-picker
          v-model="dates"
          :events="events"
          range
        ></v-date-picker>
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="dateRangeText"
          label="Date range"
          prepend-icon="mdi-calendar"
          readonly
        ></v-text-field>
        <v-text-field
          v-model="offset"
          label="Offset"
          type="number"
          min="3"
          max="100"
          prepend-icon="mdi-calendar"
        ></v-text-field>
        <v-btn
          :disabled="inputInvalid"
          color="primary"
          style="position: absolute;bottom: 20px;right: 20px;"
          @click="saveDialog = true"
        >
          Speichern
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog
      v-if="!inputInvalid && !loading"
      v-model="saveDialog"
      width="700"
      scrollable
      persistent
    >
      <v-card :loading="loading">
        <v-card-title class="text-h5">
          Speichern
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <div class="pt-4">
            <v-checkbox v-model="rangeConfirmation" class="mt-6" dense>
              <template v-slot:label>
                <div>
                  <v-icon
                    class="justify-end align-end mr-2"
                    :color="rangeConfirmation ? 'success' : 'error'"
                  >
                    <template v-if="rangeConfirmation">
                      {{ icons.mdiCheck }}
                    </template>
                    <template v-else>
                      {{ icons.mdiClose }}
                    </template>
                  </v-icon>
                  <span>Soll die Range auf {{ dateRangeText }} geändert werden?</span>
                </div>
              </template>
            </v-checkbox>

            <v-checkbox v-model="offsetConfirmation" class="mt-0" dense>
              <template v-slot:label>
                <div>
                  <v-icon
                    class="justify-end align-end mr-2"
                    :color="offsetConfirmation ? 'success' : 'error'"
                  >
                    <template v-if="offsetConfirmation">
                      {{ icons.mdiCheck }}
                    </template>
                    <template v-else>
                      {{ icons.mdiClose }}
                    </template>
                  </v-icon>
                  <span>Soll der Offset auf {{ offset }} geändert werden?</span>
                </div>
              </template>
            </v-checkbox>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn :disabled="loading" color="primary" text @click="saveDialog = false">
            Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn :disabled="!offsetConfirmation || !rangeConfirmation" :loading="loading" color="success" text @click="save">
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { HTTP } from '@/main/httpClient.js';
import NotificationObject from '@/main/NotificationObject.js';
import {
  mdiCheck,
  mdiClose,
} from '@mdi/js';

export default {
  name: 'SetActivationDateCutoff',
  components: {},
  props: {},
  data: () => ({
    icons: {
      mdiCheck,
      mdiClose,
    },
    loading: true,
    submitting: false,
    dates: [],
    dateFrom: null,
    dateTo: null,
    offset: 10,
    saveDialog: false,
    rangeConfirmation: false,
    offsetConfirmation: false
  }),
  computed: {
    inputInvalid() {
      if (!this.dates || this.dates?.length !== 2) return true;
      if (!this.offset || this.offset <= 3 || this.offset >= 20) return true;
      if (this.durationInDays <= 0) return true;

      return false;
    },
    dateRangeText() {
      if (this.dates?.length !== 2) return;
      const [from, to] = this.dates;
      const fromDate = new Date(from);
      const toDate = new Date(to);

      return `${fromDate.toLocaleDateString()} - ${toDate.toLocaleDateString()}`;
    },
    durationInDays() {
      if (this.dates?.length !== 2) return;
      const [from, to] = this.dates;
      const fromDate = new Date(from);
      const toDate = new Date(to);

      return this.daysBetween(fromDate, toDate);
    },
    bspValues() {
      if (this.dates?.length !== 2 || !(this.offset >= 1)) return [];
      const [from] = this.dates;
      const fromDate = new Date(Date.parse(from));

      return [...Array(this.durationInDays)].map(() => {
        fromDate.setDate(fromDate.getDate() + 1);
        const dateWithOffset = new Date(fromDate.getTime());
        dateWithOffset.setDate(dateWithOffset.getDate() + this.offset);
        return `${fromDate.toLocaleDateString()} -> ${dateWithOffset.toLocaleDateString()}`;
      }).join('\n');
    },
    events() {
      if (this.dates?.length !== 2 || !(this.offset >= 1)) return [];
      const [, to] = this.dates;
      const toDate = new Date(Date.parse(to));

      return [...Array(Number.parseInt(this.offset))].map(() => {
        toDate.setDate(toDate.getDate() + 1);
        return toDate.toISOString().slice(0, 10);
      });
    }
  },
  mounted() {
    this.loading = true;
    HTTP.get('setting/activation-cutoff-date').then(({ status, data }) => {
      this.dates = [
        data.from,
        data.to
      ];

      this.offset = data.offset;
      this.loading = false;
    });
  },
  methods: {
    save() {
      if (this.inputInvalid || this.rangeConfirmation !== true || this.offsetConfirmation !== true) return;
      this.submitting = true;
      HTTP.put('setting/activation-cutoff-date', {
        from: this.dates[0],
        to: this.dates[1],
        offset: this.offset
      })
        .then(({ status }) => {
          if (status !== 204) {
            this.showToast('Fehler beim speichern der Daten');
          } else {
            this.showToast('Die Daten wurden erfolgreich gespeichert', 'success');
          }
        })
        .finally(() => {
          this.loading = false;
          this.saveDialog = false;
          this.rangeConfirmation = false;
          this.offsetConfirmation = false;
        })
    },
    daysBetween: function (date1, date2) {
      const msPerDay = 24 * 60 * 60 * 1000;
      return Math.floor(Math.abs(date2 - date1) / msPerDay);
    },
    showToast: function (message, type = 'error') {
      this.$store.commit(
        'addNotification',
        new NotificationObject(type, message)
      );
    }
  }
};
</script>
